import StoreState from "../../interfaces/store/storeState";
import {Selector} from "./selectorType";

export const selectDescription: Selector<string | undefined> = (
    ({job: {selectedJob}}: StoreState): string | undefined => selectedJob?.longDescription);
